import { Suspense } from 'react';
import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import UnAuthorized from '../components/errors/401';
import Forbidden from '../components/errors/403';
import NotFound from '../components/errors/404';
import Login from '../components/features/authentication/login/login';
import MainApp from '../containers/App/MainApp';
import PrivateRoutes from './PrivateRoutes';
import { RoleGroup } from './Roles';
import Home from '../components/features/chat-bot/chatBot';
import ForgotPassword from '../components/features/authentication/forgot-password/forgotPassword';
import Health from '../components/features/healthcheckup/Health';

const AppRoutes = () => {
	// const authenticationToken = sessionStorage?.getItem('accessToken');

	const authUser: any | null = localStorage.getItem("authUser") 
	? JSON.parse(localStorage.getItem("authUser") as string) 
	: null;

	const loginRoutes: RouteObject = {
		path: '/',
		children: [
			
			{
				path: '/',
				element: authUser?.value?.AUTHTOKEN ? <Navigate to="/home" /> : <Login />
				// element:  <Login />
			},
			{
				path: '/forgot-password',
				element: <ForgotPassword />
			},
			
			{
				path: '/health',
				element: (
					// <PrivateRoutes >
						<Health />
					//  </PrivateRoutes>
				)
			}
		]
	};

	const userRoutes: RouteObject = {
		path: '/',
		element: <MainApp />,
		children: [
			{
				path: '/home',
				element: (
					<PrivateRoutes >
					 {authUser?.value?.AUTHTOKEN ? <Home /> : <Navigate to="/" />}
						{/* <Home /> */}
					 </PrivateRoutes>
				)
			}
		]
	};

	const errorRoutes = {
		path: '/',
		children: [
			{
				path: '/401',
				element: <UnAuthorized />
			},
			{
				path: '/',
				element: <Login />
			},
			{
				path: '/403',
				element: <Forbidden />
			},
			{
				path: '*',
				element: <NotFound />
			}
		]
	};

	const router = useRoutes([loginRoutes, userRoutes, errorRoutes]);
	return <Suspense>{router}</Suspense>;
};

export default AppRoutes;
